import * as React from 'react';

import { translate } from '~l10n/client';

import { toNumber, toPrecision } from '~shared/utils/number';
import { QuestionScore } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { useResultQuestionState } from '../ActivityResult/ActivityResultQuestionProvider';
import { assignedGradingWeight } from '../ActivityResult/scoreCalculation/calculateQuestionWeight';

export function ResultsQuestionGradingWeight() {
  const { questionScore, question } = useResultQuestionState();
  return <GradingWeight questionScore={questionScore} question={question} />;
}

const GradingWeight = ({
  question,
  questionScore,
}: {
  question: QuizQuestion;
  questionScore: QuestionScore;
}) => {
  const gradingWeight = assignedGradingWeight({ question, questionScore });
  const points = toNumber(toPrecision(gradingWeight, 2));
  return (
    <span className="text-xs font-600 leading-6 text-blue-900 uppercase">
      {points === 1
        ? translate('1 point')
        : translate('{0} points').format(points)}
    </span>
  );
};
